import React from 'react';
import { UploadDocumentButton } from 'framework/documentStorage';
import { useDocumentStorageContext } from 'framework/documentStorage';
import {
  OPERATIONAL_ASSETS_DOCUMENT_SECTIONS,
  PROCESS_ASSETS_STATUS,
  UPLOAD_PROCESS_ASSETS,
} from 'domain/gpo/processAssets/constants';
import ProcessAssetsForm from 'domain/gpo/processAssets/createupdate/ProcessAssetsForm';

const UploadProcessAssetsButton = () => {
  const { uploadDocument, getValidationSchema } = useDocumentStorageContext();

  return (
    <UploadDocumentButton
      permission={UPLOAD_PROCESS_ASSETS}
      uploadMethod={uploadDocument}
      getValidationSchemaFunc={getValidationSchema}
      title="Upload: New template"
      buttonText="New template"
      sxButton={{
        fontSize: '14px',
      }}
      initialData={{
        paths: [],
        section: OPERATIONAL_ASSETS_DOCUMENT_SECTIONS.HR,
        status: PROCESS_ASSETS_STATUS.UNPUBLISHED,
      }}
      isHideDefaultButtons
    >
      <ProcessAssetsForm />
    </UploadDocumentButton>
  );
};

export default UploadProcessAssetsButton;
